"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_dial__pad__dark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "dial_pad_hi_dark",
    "data-name": "dial+pad_hi_dark",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 192 192",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 80.05,
    y: 144,
    width: 31.95,
    height: 32,
    rx: 3.44,
    style: {
      fill: "#e60000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.56,172H83.49a3.44,3.44,0,0,1-3.44-3.44v4A3.44,3.44,0,0,0,83.49,176h25.07a3.44,3.44,0,0,0,3.44-3.44v-4A3.44,3.44,0,0,1,108.56,172Z",
    style: {
      opacity: 0.12
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 80.05,
    y: 104,
    width: 31.95,
    height: 32,
    rx: 3.44,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.56,132H83.49a3.44,3.44,0,0,1-3.44-3.44v4A3.44,3.44,0,0,0,83.49,136h25.07a3.44,3.44,0,0,0,3.44-3.44v-4A3.44,3.44,0,0,1,108.56,132Z",
    style: {
      opacity: 0.12
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 80.05,
    y: 64,
    width: 31.95,
    height: 32,
    rx: 3.44,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.56,92H83.49a3.44,3.44,0,0,1-3.44-3.44v4A3.44,3.44,0,0,0,83.49,96h25.07A3.44,3.44,0,0,0,112,92.56v-4A3.44,3.44,0,0,1,108.56,92Z",
    style: {
      opacity: 0.12
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 80.05,
    y: 24,
    width: 31.95,
    height: 32,
    rx: 3.44,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.56,52H83.49a3.44,3.44,0,0,1-3.44-3.44v4A3.44,3.44,0,0,0,83.49,56h25.07A3.44,3.44,0,0,0,112,52.56v-4A3.44,3.44,0,0,1,108.56,52Z",
    style: {
      opacity: 0.12
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 104,
    width: 31.95,
    height: 32,
    rx: 3.44,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.51,132H127.44a3.44,3.44,0,0,1-3.44-3.44v4a3.44,3.44,0,0,0,3.44,3.44h25.07a3.44,3.44,0,0,0,3.44-3.44v-4A3.44,3.44,0,0,1,152.51,132Z",
    style: {
      opacity: 0.12
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 64,
    width: 31.95,
    height: 32,
    rx: 3.44,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.51,92H127.44A3.44,3.44,0,0,1,124,88.56v4A3.44,3.44,0,0,0,127.44,96h25.07A3.44,3.44,0,0,0,156,92.56v-4A3.44,3.44,0,0,1,152.51,92Z",
    style: {
      opacity: 0.12
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 24,
    width: 31.95,
    height: 32,
    rx: 3.44,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.51,52H127.44A3.44,3.44,0,0,1,124,48.56v4A3.44,3.44,0,0,0,127.44,56h25.07A3.44,3.44,0,0,0,156,52.56v-4A3.44,3.44,0,0,1,152.51,52Z",
    style: {
      opacity: 0.12
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 104,
    width: 31.95,
    height: 32,
    rx: 3.44,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.51,132H39.44A3.44,3.44,0,0,1,36,128.56v4A3.44,3.44,0,0,0,39.44,136H64.51A3.44,3.44,0,0,0,68,132.56v-4A3.44,3.44,0,0,1,64.51,132Z",
    style: {
      opacity: 0.12
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 64,
    width: 31.95,
    height: 32,
    rx: 3.44,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.51,92H39.44A3.44,3.44,0,0,1,36,88.56v4A3.44,3.44,0,0,0,39.44,96H64.51A3.44,3.44,0,0,0,68,92.56v-4A3.44,3.44,0,0,1,64.51,92Z",
    style: {
      opacity: 0.12
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 24,
    width: 31.95,
    height: 32,
    rx: 3.44,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.51,52H39.44A3.44,3.44,0,0,1,36,48.56v4A3.44,3.44,0,0,0,39.44,56H64.51A3.44,3.44,0,0,0,68,52.56v-4A3.44,3.44,0,0,1,64.51,52Z",
    style: {
      opacity: 0.12
    }
  }))), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    style: {
      fill: "none"
    }
  })));
}

var _default = ic_dial__pad__dark;
exports.default = _default;